<template>
  <template v-if="!loading && detail">
    <formations-details-main
      v-bind:detail="detail"
      v-bind:open_elearning_module="computeElearningModule"
      v-bind:open_elearning_retractation_module="
        openDemandeRetractationModal
      " />
    <refonte-collapse
      v-if="detail.titre"
      class="mt-[12px]"
      v-bind:title_icon="IconMyAccount"
      title="Synthèse"
      v-bind:start_open="true">
      <template v-if="detail.participant">
        <refonte-table
          key="participant-1"
          table_index="participant-1"
          v-bind:columns="columnsSynthese"
          v-bind:data="[detail.synthese]">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      class="mt-[12px]"
      v-bind:title_icon="IconInformation"
      title="Informations importantes"
      v-bind:start_open="true"
      v-if="detail.infosParticulieresProduit || detail.elearningQuestion">
      <div
        class="ml-[20px] p-2"
        v-html="detail.infosParticulieresProduit" />
      <refonte-button
        v-if="detail.elearningQuestion"
        variant="secondary"
        class="mb-[10px] ml-[20px] mt-[10px]"
        v-bind:icon_left="IconModify"
        v-bind:on_click="
          () => {
            openElearningModal();
          }
        ">
        {{ labelBtnQuestionElearning }}
      </refonte-button>
    </refonte-collapse>
    <refonte-collapse
      v-if="
        detail.titre &&
        detail?.moduleElearning?.cours &&
        detail?.moduleElearning?.cours?.length > 0
      "
      class="mt-[12px]"
      v-bind:title_icon="IconCatalogue"
      title="Chapitres elearning"
      v-bind:start_open="true">
      <refonte-button
        class="elearning-btn mx-5 mb-1 mt-3"
        v-bind:icon_left="IconOpenNewTab"
        v-bind:disabled="!!detail?.moduleElearning?.dateDemandeRetractation"
        v-tooltip="
          detail?.moduleElearning?.dateDemandeRetractation
            ? {
                content:
                  'L\'accès au module e-learning est désactivé suite à votre demande de rétractation.',
                placement: 'left'
              }
            : {}
        "
        v-if="detail.type.id === 2 && detail?.moduleElearning?.accessible"
        v-bind:on_click="computeElearningModule">
        Accéder au module
      </refonte-button>
      <template
        v-if="
          detail.moduleElearning && detail?.moduleElearning.cours.length > 0
        ">
        <refonte-table
          key="cours-1"
          table_index="cours-1"
          v-bind:columns="columnsModuleElearning"
          v-bind:data="detail?.moduleElearning?.cours">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="
        detail.titre &&
        detail?.support?.supports &&
        detail?.support?.supports?.length > 0
      "
      class="mt-[12px]"
      v-bind:title_icon="IconTestValidation"
      title="Supports pédagogiques"
      v-bind:start_open="true">
      <template v-if="detail.support && detail?.support.supports.length > 0">
        <refonte-table
          key="supports-1"
          table_index="supports-1"
          v-bind:columns="columnsSupports"
          v-bind:data="detail?.support?.supports">
        </refonte-table>
        <refonte-button
          v-if="supportWithUrl > 1"
          class="item-convention-content-download mx-5 my-3"
          variant="secondary"
          v-bind:icon_left="IconDownload"
          v-on:click="downloadSupports"
          >Télécharger tous les fichiers (.zip)
        </refonte-button>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
  </template>
  <spinner
    v-else
    sizes="w-20 h-20"
    thickness="border-8" />

  <refonte-modal-questionnaire-satisfaction-participant
    v-if="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:show="isParticipantQuestionnaireSatisfactionModalOpen"
    v-bind:on_close="closeParticipantQuestionnaireSatisfactionModal"
    v-bind:on_complete="fetchFormationDetail"
    v-bind:formation="detail" />

  <formations-elearning-question-modal
    v-if="detail?.titre"
    v-bind:titre="detail.titre"
    v-bind:elearning_participant_id="detail.id"
    v-bind:plateforme_duree_acces="detail.plateformeDureeAcces"
    v-bind:module_elearning="detail.moduleElearning"
    v-bind:questions="
      detail.elearningQuestion && detail.elearningQuestion.questions
        ? detail.elearningQuestion.questions
        : []
    "
    v-bind:autoriser_question="
      detail.elearningQuestion && detail.elearningQuestion.autoriserQuestion
    "
    v-bind:fetch_formation_detail="loadFormationDetail"
    v-bind:show="elearning_question_modal"
    v-bind:on_close="closeElearningModal" />
  <refonte-modal-appreciation
    v-bind:show="isParticipantAppriciationModalOpen"
    v-bind:on_close="closeAppreciationModal"
    v-bind:elearning="true" />
  <formations-elearning-retractation-modal
    v-if="detail"
    v-bind:show="showRetractationModal"
    v-bind:on_close="closeRetractationModal"
    v-bind:formation="mapRetractationFormation(detail)"
    v-bind:open_elearning_module="openElearningModuleAndRefresh" />

  <formations-elearning-demande-retractation-modal
    v-if="detail"
    v-bind:show="showDemandeRetractationModal"
    v-bind:on_close="closeDemandeRetractationModal"
    v-bind:formation="mapRetractationFormation(detail)"
    v-bind:confirm="handleDemandeRetractation" />
  <refonte-modal-support-file-size-exceeded
    title="Téléchargement impossible"
    v-bind:show="showFileSizeModal"
    v-bind:on_close="closeFileSizeModal" />
</template>
<script setup lang="ts">
  import Spinner from '@/components/utils/spinner.vue';
  import { computed, h, onMounted, ref, watch } from 'vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconCatalogue from '@/assets/img/refonte/icons/menu/icon-catalogue.svg?component';
  import IconInformation from '@/assets/img/refonte/icons/information/icon-information.svg?component';
  import IconTestValidation from '@/assets/img/refonte/icons/information/icon-test-validation.svg?component';
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import IconOpenNewTab from '@/assets/img/refonte/icons/action/icon-open-new-tab.svg?component';
  import {
    FormationsDetail,
    SatisfactionStatus,
    Synthese,
    TestValidationStatus
  } from '@/types/participant/formations-details-types';
  import RefonteSearchResultsEmpty from '@/components/refonte/inputs/refonte-search-results-empty.vue';
  import RefonteTable from '@/components/refonte/tables/refonte-table.vue';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import { useRoute } from 'vue-router';
  import FormationsDetailsMain from '@/views/_espace/_refonte/participant/_formations-details/formations-details-main.vue';
  import RefonteTableParticipantFormationTestValidationAquis from '@/components/refonte/tables/refonte-table-participant-formation-test-validation-aquis.vue';
  import IconModify from '@/assets/img/refonte/icons/action/icon-modify.svg?component';
  import IconValidate20Green from '@/assets/img/refonte/icons/information/icon-validate-20-green.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import FormationsElearningQuestionModal from '@/views/_espace/_refonte/participant/_formations-details/formations-elearning-question-modal.vue';
  import { API } from '@/http-common';
  import RefonteModalAppreciation from '@/components/refonte/modals/refonte-modal-appreciation.vue';
  import {
    downloadAttestationParticipant,
    downloadSupportFormation,
    downloadSupportsZip,
    isFileSizeLimitExceeded
  } from '@/mixin/participant_download_functions';
  import RefonteModalQuestionnaireSatisfactionParticipant from '@/components/refonte/modals/refonte-modal-questionnaire-satisfaction-participant.vue';
  import FormationsElearningRetractationModal from '@/views/_espace/_refonte/participant/_formations/formations-elearning-retractation-modal.vue';
  import FormationsElearningDemandeRetractationModal from '@/views/_espace/_refonte/participant/_formations/formations-elearning-demande-retractation-modal.vue';
  import { RetractationFormation } from '@/types/participant/formations-types';
  import RefonteModalSupportFileSizeExceeded from '@/components/refonte/modals/refonte-modal-support-file-size-exceeded.vue';

  const detail = ref<FormationsDetail>();
  const route = useRoute();
  const loading = ref<boolean>(false);
  const id = computed(() => route.query.id);
  const isParticipantQuestionnaireSatisfactionModalOpen = ref<boolean>(false);
  const isParticipantAppriciationModalOpen = ref<boolean>(false);

  watch(
    () => route.query.id,
    () => loadFormationDetail()
  );

  const downloadSupports = () => {
    if (isFileSizeLimitExceeded(detail.value?.support?.supports)) {
      openFileSizeModal();
    } else {
      downloadSupportsZip(
        detail.value?.commandeId,
        detail.value?.catalogueReference
      );
    }
  };
  const fetchFormationDetail = async () => {
    if (id.value) {
      const response = await API.get(
        `/participant/v2/formations/elearning/${id.value}/details`
      );

      if (response && response.data) {
        detail.value = mapFormationDetail(response.data);
      }
    }
  };

  const loadFormationDetail = async () => {
    loading.value = true;
    await fetchFormationDetail();
    loading.value = false;
  };

  const mapFormationDetail = (detail) => {
    return {
      ...detail,
      support: {
        ...detail.support,

        supports: detail?.support?.supports.map((s) => mapSupport(s, detail))
      },
      participant: {
        ...detail.participant,
        produitTitre: detail?.titre
      }
    };
  };
  const mapSupport = (support, detail) => {
    return {
      ...support,
      supportLabel: 'Télécharger',
      reference: detail.catalogueReference,
      commandeId: detail.commandeId,
      parcoursProduitId: detail.isSousProduitParcours
        ? detail.produitId
        : undefined,
      participantId: detail.id,
      type: detail.type
    };
  };

  onMounted(async () => {
    await loadFormationDetail();
  });

  function openParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = true;
  }

  function closeParticipantQuestionnaireSatisfactionModal() {
    isParticipantQuestionnaireSatisfactionModalOpen.value = false;
  }

  const getParticipantInscriptionStatus = (status: string) => {
    switch (status) {
      case 'En attente':
        return 'En attente';
      case 'Confirmé':
        return 'Confirmée';
      case 'Annulé':
        return 'Annulée';
      case 'Transférée':
        return 'Annulée';
      default:
        return '-';
    }
  };

  const columnsSynthese = computed(() => [
    {
      content_index: 'inscription',
      label: 'Inscription',
      width: 80,
      content_custom: (row: Synthese) =>
        h('span', {
          innerHTML: getParticipantInscriptionStatus(row.inscription.label)
        })
    },
    ...(detail.value?.synthese.statutElearning
      ? [
          {
            content_index: 'statutElearning',
            label: 'Statut Elearning',
            width: 150
          }
        ]
      : []),
    ...(detail.value?.synthese.satisfaction
      ? [
          {
            content_index: 'validation',
            label: 'T. valid. acquis',
            width: 80,
            label_icon: IconInformation,
            label_icon_tooltip:
              "À l'issue de la session, si vous réalisez votre test au-delà de 8 jours, l'attestation de formation sera automatiquement générée avec la mention \"Résultat de l'évaluation des acquis : non réalisé\". Au-delà de ce délai, vous pouvez réaliser le test à titre d'auto-évaluation, mais l'attestation de formation ne sera pas mise à jour automatiquement.",
            content_custom: (row: Synthese) =>
              h(RefonteTableParticipantFormationTestValidationAquis, { row }),
            class: (row: Synthese) =>
              row.validation?.id === TestValidationStatus.A_REALISE ||
              (row.validation?.nombreTentativesRestantes &&
                row.validation?.nombreTentativesRestantes > 0)
                ? 'btn-border'
                : ''
          },
          {
            content_index: 'satisfaction',
            label: 'Satisfaction',
            width: 80,
            content_custom: (row: Synthese) =>
              h('span', {
                innerHTML: row.satisfaction ? row.satisfaction.label : '-'
              }),
            content_icon: (row: Synthese) => {
              const id = row.satisfaction?.id;
              if (id === SatisfactionStatus.A_REALISE) return IconModify;
              if (id === SatisfactionStatus.REALISE) return IconValidate20Green;
              return null;
            },
            on_click: (row: Synthese) => {
              if (row.satisfaction?.id === SatisfactionStatus.A_REALISE) {
                openParticipantQuestionnaireSatisfactionModal();
              }
            },
            on_click_disabled: (row: Synthese) =>
              row.satisfaction?.id !== SatisfactionStatus.A_REALISE,
            class: (row: Synthese) =>
              row.satisfaction?.id === SatisfactionStatus.A_REALISE
                ? 'btn-border'
                : ''
          }
        ]
      : []),
    {
      content_index: 'attestation',
      label: 'Attestation',
      width: 80,
      content_custom: () =>
        h('span', {
          innerHTML: detail?.value?.attestationId ? 'Télécharger' : '-'
        }),
      on_click: () => {
        if (detail?.value?.attestationId) {
          downloadAttestationParticipant(detail.value.attestationId);
        }
      },
      content_icon: () => detail?.value?.attestationId && IconDownload,
      is_pending: () => !detail?.value?.attestationId,
      class: () =>
        detail?.value?.attestationId
          ? '!flex-grow-0 btn-border'
          : '!flex-grow-0'
    }
  ]);

  const columnsModuleElearning = [
    {
      content_index: 'titre',
      label: 'Titre',
      width: 150
    },
    {
      content_index: 'statutString',
      label: 'Statut',
      width: 150
    }
  ];
  const columnsSupports = [
    {
      content_index: 'titre',
      label: 'Titre',
      width: 200
    },
    {
      content_index: 'portailLabel',
      label: 'Type',
      width: 150
    },
    {
      content_index: 'version',
      label: 'Version',
      width: 150
    },
    {
      content_index: 'modifiedDate',
      label: 'Mise à jour',
      width: 150
    },
    {
      content_index: 'endDisponibiliteDate',
      label: "Disponible jusqu'au",
      width: 150
    },
    {
      content_index: 'supportLabel',
      label: 'Support',
      min_width: 140,
      width: 170,
      on_click: async (row: FormationsDetail) => {
        const result = await downloadSupportFormation(row);
        if (result?.appreciationRequired) {
          isParticipantAppriciationModalOpen.value = true;
        }
      },
      content_icon: () => IconDownload,
      class: (row: FormationsDetail) => '!flex-grow-0 btn-border'
    }
  ];

  const elearning_question_modal = ref<boolean>(false);

  const openElearningModal = () => {
    elearning_question_modal.value = true;
  };

  const closeElearningModal = () => {
    elearning_question_modal.value = false;
  };

  const closeAppreciationModal = () => {
    isParticipantAppriciationModalOpen.value = false;
  };

  const demandeRetractation = async () => {
    await API.post(
      `/participant/v2/formations/elearning/${id.value}/retractation`,
      {
        headers: { 'SKIP-REDIRECTION': true }
      }
    );
  };

  const openElearningModule = async () => {
    const response = await API.get(
      `/participant/v2/formations/elearning/${id.value}/elearning`,
      {
        headers: { 'SKIP-REDIRECTION': true }
      }
    );

    if (response && response.data && response.data.url) {
      window.open(response.data.url);
    }
  };

  const showRetractationModal = ref<boolean>(false);
  const showDemandeRetractationModal = ref<boolean>(false);
  const showFileSizeModal = ref<boolean>(false);

  const openFileSizeModal = () => {
    showFileSizeModal.value = true;
  };

  const closeFileSizeModal = () => {
    showFileSizeModal.value = false;
  };
  const computeElearningModule = () => {
    if (detail.value?.moduleElearning.showRetractation) {
      openRetractationModal();
    } else {
      openElearningModule();
    }
  };
  const openDemandeRetractationModal = () => {
    showDemandeRetractationModal.value = true;
  };

  const closeDemandeRetractationModal = () => {
    showDemandeRetractationModal.value = false;
  };
  const openElearningModuleAndRefresh = async () => {
    await openElearningModule();
    await loadFormationDetail();
    closeRetractationModal();
  };

  const handleDemandeRetractation = async () => {
    await demandeRetractation();
    await loadFormationDetail();
    closeDemandeRetractationModal();
  };

  const openRetractationModal = () => {
    showRetractationModal.value = true;
  };

  const closeRetractationModal = () => {
    showRetractationModal.value = false;
  };

  const mapRetractationFormation = (
    detail: FormationsDetail
  ): RetractationFormation => ({
    organisateurEmail: detail.organisateur.email,
    moduleElearning: detail.moduleElearning
  });

  const supportWithUrl = computed(() =>
    detail.value?.support?.supports
      ? detail.value.support.supports.filter((doc) => doc.url != null).length
      : 0
  );

  const labelBtnQuestionElearning = computed(() => {
    const questions = detail.value?.elearningQuestion?.questions;

    if (!questions) return '';

    const hasAtLeastOneAnswer = questions.some((q) => q.reponse != null);

    return hasAtLeastOneAnswer
      ? 'Voir mes questions et les réponses apportées'
      : 'Poser une question sur le module elearning';
  });
</script>

<style lang="scss" scoped>
  .table-no-space-between {
    :deep(.table-row-content) {
      justify-content: flex-start !important;

      .refonte-table-item {
        flex-grow: 0 !important;
      }
    }
  }
  .elearning-btn {
    @apply bg-refonte-e-learning #{!important};
    &:disabled {
      @apply cursor-not-allowed bg-refonte-white opacity-20;
    }
  }
  :deep(.btn-border) {
    border-width: 1px;
    border-color: rgb(164 189 218);
    border-radius: 8px;
  }
</style>
